import React from 'react';
import Calendar from '../Components/FullCalendar/FullCalendar'


export function Bookings() { 
    return (
      <div className="ms-3 me-3">  
        
        <Calendar />
      </div>
    );
   };